import { FrontendConfigurationTypes } from '../types';

export const formatCalculatedParameters = (calculatedParameters: FrontendConfigurationTypes) => {
  const regExp = /\d+/;
  return Object.keys(calculatedParameters).reduce((acc, el) => {
    if (typeof calculatedParameters[el] === 'boolean') {
      acc[el] = Boolean(calculatedParameters[el]);
      return acc;
    }
    if (typeof calculatedParameters[el] === 'number') {
      acc[el] = Number(calculatedParameters[el]);
      return acc;
    }

    if (
      typeof calculatedParameters[el] === 'string' &&
      ['true', 'false'].includes(String(calculatedParameters[el]))
    ) {
      acc[el] = calculatedParameters[el] === 'true';
      return acc;
    }

    if (typeof calculatedParameters[el] === 'string' && regExp.exec(String(calculatedParameters[el]))?.[0]) {
      acc[el] = Number(calculatedParameters[el]);
      return acc;
    }

    if (typeof calculatedParameters[el] === 'string') {
      acc[el] = String(calculatedParameters[el]);
      return acc;
    }
    return acc;
  }, {} as FrontendConfigurationTypes);
};
